exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".formCard[data-v-6f4a802e]{border:none!important;padding:0}.modal fade show d-block[data-v-6f4a802e]{background:none}.tab-list[data-v-6f4a802e]{display:flex;cursor:pointer;overflow-x:auto}.tab-list div[data-v-6f4a802e]{padding:10px;margin:5px;border:1px solid #ccc;border-radius:5px;white-space:nowrap;user-select:none;transition:background-color .3s}.tab-list div[data-v-6f4a802e]:hover{background-color:#0aa46e}.active-tab[data-v-6f4a802e]{background-color:#007bff;color:#fff}.tab-content[data-v-6f4a802e]{margin-top:10px}.fade-enter-active[data-v-6f4a802e],.fade-leave-active[data-v-6f4a802e]{transition:opacity .5s}.fade-enter[data-v-6f4a802e],.fade-leave-to[data-v-6f4a802e]{opacity:0}.custom-slide-enter-active[data-v-6f4a802e],.custom-slide-leave-active[data-v-6f4a802e]{transition:transform .5s}.custom-slide-enter[data-v-6f4a802e],.custom-slide-leave-to[data-v-6f4a802e]{transform:translateX(100%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f4a802e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/clientJob/Tab.vue
// module id = 1692
// module chunks = 0